import { render, staticRenderFns } from "./fileDownload.vue?vue&type=template&id=01f03f3e&scoped=true"
import script from "./fileDownload.vue?vue&type=script&lang=js"
export * from "./fileDownload.vue?vue&type=script&lang=js"
import style0 from "./fileDownload.vue?vue&type=style&index=0&id=01f03f3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f03f3e",
  null
  
)

export default component.exports